module.exports = __webpack_public_path__ + "static/media/hackster.225f5d9a.png";